import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-df-transaction-quick-filter',
  templateUrl: './df-transaction-quick-filter.component.html',
  styleUrls: ['./df-transaction-quick-filter.component.scss']
})
export class DfTransactionQuickFilterComponent {

  @Input() public hasLargeIcon = false;
  @Input() public asset: string;
  @Input() public labelKey: string;
  @Input() public count: number;
  @Output() public useQuickFilter = new EventEmitter<void>();

}
